// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__cEppE","customBox":"styles_customBox__bJfyN","contentBox":"styles_contentBox__3nzjp","link":"styles_link__2Ikx7","headingBox":"styles_headingBox__halqx"};